import type { CabDefinitionFormData } from '../types/cabDefinition';
import { hasActualTextContent } from './sanitize';

export type CabDefinitionFormErrors = Partial<Record<keyof CabDefinitionFormData, string>>;

export function validateCabDefinitionForm(data: CabDefinitionFormData): CabDefinitionFormErrors {
  const errors: CabDefinitionFormErrors = {};

  const name = data.name.trim();
  if (!name) {
    errors.name = 'Name is required';
  } else if (name.length > 255) {
    errors.name = 'Name must be 255 characters or fewer';
  }

  if (!data.cabManager) {
    errors.cabManager = 'CAB Manager is required';
  }

  if (!data.cabType) {
    errors.cabType = 'CAB Type is required';
  }

  if (!data.conferenceType?.trim()) {
    errors.conferenceType = 'Conference Details are required.';
  }

  const isTeams = /teams/i.test(data.conferenceType || '');
  const teamsUrl = (data.teamsMeetingUrl || '').trim();
  if (isTeams && !teamsUrl) {
    errors.teamsMeetingUrl = 'Teams Meeting Link is required.';
  }

  if (
    !teamsUrl &&
    !hasActualTextContent(data.conferenceDetails || '') &&
    !data.meetingSubject?.trim()
  ) {
    errors.conferenceDetails = 'Conference Details are required.';
  }

  return errors;
}

export function hasValidationErrors(errors: CabDefinitionFormErrors): boolean {
  return Object.keys(errors).length > 0;
}
